import { dataHooks } from '@wix/data-hooks'

export const wixelSplitDataHooks = dataHooks<{
  title: {}
  option: { key: string }
  skip: {}
}>('wixel-split')
